// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CollaspedFillSvg from '@rsuite/icon-font/lib/action/CollaspedFill';
var CollaspedFill = createSvgIcon({
  as: CollaspedFillSvg,
  ariaLabel: 'collasped fill',
  category: 'action',
  displayName: 'CollaspedFill'
});
export default CollaspedFill;